import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { Overlay } from "components/generic/layout";
import { candidate } from "routes/paths";

export default ({ children }) => (
  <Overlay
    right={
      <div>
        <SignUp to={candidate.signUp}>
          <Overlay.Link>Create a new account</Overlay.Link>
        </SignUp>
      </div>
    }
  >
    {children}
  </Overlay>
);

const SignUp = styled(Link)`
  border-radius: 100px;
  border: 2px solid #000;
  text-decoration: none;
  color: #000000;
  padding: 10px 23px;
`;



// WEBPACK FOOTER //
// ./src/components/common/auth/SignInLayout/index.js